// Supported Countries with currency info
export const COUNTRIES = {
  US: { name: 'United States', currency: 'USD', symbol: '$', locale: 'en-US' },
  IN: { name: 'India', currency: 'INR', symbol: '₹', locale: 'en-IN' },
  GB: { name: 'United Kingdom', currency: 'GBP', symbol: '£', locale: 'en-GB' },
  CA: { name: 'Canada', currency: 'CAD', symbol: 'C$', locale: 'en-CA' },
  AU: { name: 'Australia', currency: 'AUD', symbol: 'A$', locale: 'en-AU' },
  DE: { name: 'Germany', currency: 'EUR', symbol: '€', locale: 'de-DE' },
  FR: { name: 'France', currency: 'EUR', symbol: '€', locale: 'fr-FR' },
  JP: { name: 'Japan', currency: 'JPY', symbol: '¥', locale: 'ja-JP' },
  BR: { name: 'Brazil', currency: 'BRL', symbol: 'R$', locale: 'pt-BR' },
  MX: { name: 'Mexico', currency: 'MXN', symbol: 'MX$', locale: 'es-MX' },
  AE: { name: 'UAE', currency: 'AED', symbol: 'د.إ', locale: 'ar-AE' },
  SG: { name: 'Singapore', currency: 'SGD', symbol: 'S$', locale: 'en-SG' },
};

// Currency formatting helper
export const formatCurrency = (amount, countryCode = 'US') => {
  const country = COUNTRIES[countryCode] || COUNTRIES.US;
  return `${country.symbol}${Number(amount).toLocaleString(country.locale)}`;
};

// Get user's currency symbol
export const getUserCurrencySymbol = (user) => {
  const countryCode = user?.location?.country_code || 
                      user?.creator_profile?.country_code || 
                      user?.brand_profile?.country_code || 
                      'US';
  return COUNTRIES[countryCode]?.symbol || '$';
};

// Get user's country info
export const getUserCountry = (user) => {
  const countryCode = user?.location?.country_code || 
                      user?.creator_profile?.country_code || 
                      user?.brand_profile?.country_code || 
                      'US';
  return { code: countryCode, ...COUNTRIES[countryCode] };
};
